import ACTIONS from 'constants/actionTypes';
import { createAction } from 'helpers/redux';

export const addLocalizationDictionary = (
  localeDictionaries: Record<string, Record<string, string>>
) => {
  return (dispatch) => {
    dispatch(
      createAction({
        type: ACTIONS.ADD_LOCALIZATION_DICTIONARY,
        payload: { localeDictionaries },
      })
    );
  };
};

export const changeLocalizationLanguage = (interfaceLang: string) => {
  return (dispatch) => {
    dispatch(
      createAction({
        type: ACTIONS.CHANGE_LOCALIZATION_LANGUAGE,
        payload: { interfaceLang },
      })
    );
  };
};
